import React, { useState } from "react";
import {
  Stack,
  IconButton,
  Box,
  TextField,
  Typography,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { MdOutlineAddCircleOutline, MdDeleteOutline } from "react-icons/md";

export default function ListTotalCashUSD({
  handleUpdatePriceUSD,
  handleUpdateQTYUSD,
  handleUpdateValueUSD,
  handleDeleteCashUSD,
  handleAddCashUSD,
  totalCashUSDList,
  requireField,
}) {
  const [touched, setTouched] = useState(false);
  const handleTouched = (e) => {
    setTouched(true);
    e.target.select();
  };

  return (
    <Stack direction="column" spacing={1}>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          backgroundColor: "#E6F1EE",
          borderRadius: "5px",
          padding: "0px 3px 0px 6px",
        }}
      >
        <Stack direction="column" width="31%">
          <Typography className="field-title">សាច់ប្រាក់</Typography>
        </Stack>
        <Stack direction="column" width="30%">
          <Typography className="field-title"> ចំនួន </Typography>
        </Stack>
        <Stack direction="column" width="31%">
          <Typography className="field-title"> សាច់ប្រាក់សរុប</Typography>
        </Stack>
        <Stack direction="column" width="8%">
          <Box>
            <IconButton onClick={handleAddCashUSD}>
              <MdOutlineAddCircleOutline color="#007654" />
            </IconButton>
          </Box>
        </Stack>
      </Stack>
      <Stack direction="column" spacing={1}>
        {totalCashUSDList?.map((row, index) => {
          return (
            <Stack direction="row" width="100%" spacing={1} key={index}>
              <Stack direction="column" width="42%">
                <FormControl className="text-field" fullWidth size="small">
                  <Select
                    value={row?.cash}
                    onChange={(e) => {
                      handleUpdatePriceUSD(e?.target.value, row?.key);
                    }}
                    error={
                      (touched && row?.cash === undefined) ||
                      (touched && row?.cash === null) ||
                      (touched && row?.cash === "") ||
                      (touched && row?.cash <= 0) ||
                      (requireField && row?.cash === undefined) ||
                      (requireField && row?.cash === "") ||
                      (requireField && row?.cash <= 0) ||
                      (requireField && row?.cash === null)
                    }
                  >
                    <MenuItem value={100}>100</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
              <Stack direction="column">
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={row?.qty}
                  onChange={(e) =>
                    handleUpdateQTYUSD(e?.target?.value, row?.key)
                  }
                  onFocus={handleTouched}
                  error={
                    (touched && row?.qty === undefined) ||
                    (touched && row?.qty === null) ||
                    (touched && row?.qty === "") ||
                    (touched && row?.qty <= 0) ||
                    (requireField && row?.qty === undefined) ||
                    (requireField && row?.qty === "") ||
                    (requireField && row?.qty <= 0) ||
                    (requireField && row?.qty === null)
                  }
                />
              </Stack>
              <Stack direction="column">
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={row?.cash * row?.qty}
                  // onChange={(e) =>
                  //   handleUpdateValueUSD(e?.target?.value, row?.key)
                  // }
                  // onFocus={handleTouched}
                  // error={
                  //   (touched && row?.value === undefined) ||
                  //   (touched && row?.value === null) ||
                  //   (touched && row?.value === "") ||
                  //   (touched && row?.value === 0) ||
                  //   (requireField && row?.value === undefined) ||
                  //   (requireField && row?.value === "") ||
                  //   (requireField && row?.value === 0) ||
                  //   (requireField && row?.value === null)
                  // }
                  disabled
                />
              </Stack>
              <Stack direction="column" width="8%">
                <Box>
                  <IconButton onClick={() => handleDeleteCashUSD(row.key)}>
                    <MdDeleteOutline color="#f44336" />
                  </IconButton>
                </Box>
              </Stack>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
}
